module.exports = __webpack_public_path__ + "static/media/how-we-work3.322f6f1c.svg";